import { render } from "./UCSearchEmpty.vue?vue&type=template&id=1625e4e4&scoped=true"
import script from "./UCSearchEmpty.vue?vue&type=script&lang=js"
export * from "./UCSearchEmpty.vue?vue&type=script&lang=js"

import "./UCSearchEmpty.vue?vue&type=style&index=0&id=1625e4e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1625e4e4"]])

export default __exports__